module.exports = __webpack_public_path__ + "static/img/test-drive.bf0747f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/newHome/test-drive.png
// module id = wnZM
// module chunks = 1